var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showComponent
    ? _c(
        "div",
        { staticClass: "media-gallery-selected-filters" },
        [
          _vm.keyword
            ? _c(
                "global-filter-selected",
                { on: { click: _vm.resetKeyword } },
                [
                  _vm._v('"'),
                  _c("i", [_vm._v(_vm._s(_vm.keyword))]),
                  _vm._v('"'),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.selectedOptions, function (filter) {
            return [
              _c(
                "global-filter-selected",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleFilterRemove({
                        filterName: filter.filterName,
                        optionName: filter.optionName,
                      })
                    },
                  },
                },
                [_vm._v(_vm._s(filter.optionTitle))]
              ),
            ]
          }),
          _vm._v(" "),
          _c(
            "global-button",
            {
              attrs: { icon: "close", theme: "ghost" },
              on: { click: _vm.reset },
            },
            [_vm._v(_vm._s(_vm.$t("mediaGallery.filter.reset")))]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }